import { produce } from 'immer';
import { ADD_PLAYER_AUTO_RELOAD_BUYIN_BUBBLE, ADD_PLAYER_REVEALED_HAND_BUBBLE, CLEAR_BUBBLES_STATE, REMOVE_PLAYER_BUBBLE } from '../actions/playerBubblesActions';
import { getIncrementedId } from './utils/reducerUtils';
const initialState = {
    nextId: 0,
    bubbles: {}
};
function draftGetAndIncrementBubbleId(draft) {
    const currBubbleId = draft.nextId;
    draft.nextId = getIncrementedId(draft.nextId);
    return currBubbleId;
}
function draftAddNewBubble(draft, seatIndex, playerBubble) {
    if (!draft.bubbles[seatIndex]) {
        draft.bubbles[seatIndex] = [];
    }
    draft.bubbles[seatIndex]?.push(playerBubble);
}
const bubblesReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_BUBBLES_STATE: {
                return initialState;
            }
            case ADD_PLAYER_REVEALED_HAND_BUBBLE: {
                const { seatIndex, handName, cards } = action.payload;
                draftAddNewBubble(draft, seatIndex, {
                    id: draftGetAndIncrementBubbleId(draft),
                    performanceTimestampMs: performance.now(),
                    seatIndex,
                    lines: [`Reveals ${handName}`, cards]
                });
                break;
            }
            case ADD_PLAYER_AUTO_RELOAD_BUYIN_BUBBLE: {
                const seatIndex = action.payload;
                draftAddNewBubble(draft, seatIndex, {
                    id: draftGetAndIncrementBubbleId(draft),
                    performanceTimestampMs: performance.now(),
                    seatIndex,
                    lines: ['RELOADED!']
                });
                break;
            }
            case REMOVE_PLAYER_BUBBLE: {
                const { seatIndex, id } = action.payload;
                if (draft.bubbles[seatIndex]) {
                    draft.bubbles[seatIndex] = (draft.bubbles[seatIndex] || []).filter((playerBubble) => playerBubble.id !== id);
                    if (!draft.bubbles[seatIndex]?.length) {
                        // no player bubbles remain, remove array entirely:
                        delete draft.bubbles[seatIndex];
                    }
                }
                break;
            }
        }
    });
};
export default bubblesReducer;
